import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './en.json';
import translationTR from './tr.json';

const resources = {
  "en-US": {
  translation: translationEN,
  },
  "tr-TR": {
  translation: translationTR,
  }
 };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr-TR',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

if (i18n.language.indexOf('-') === -1)
    i18n.changeLanguage('tr-TR');
    
export default i18n;
